import { c as _c } from "react/compiler-runtime";
import { Shimmer } from '@onefootprint/ui';
const DuplicatesLoading = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex flex-col gap-3"><Shimmer width="100%" height="20px" /><Shimmer width="100%" height="144px" /><Shimmer width="100%" height="144px" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default DuplicatesLoading;